export default __webpack_public_path__ + "static/media/Straps of the Revelations.d9112a84.jpg";